import $command from '@/utils/command'

const state = {
  drawerVisible: false,
  conversations: [],
  currentConversationId: null,
  messages: [],
  isLoading: false
}

const mutations = {
  TOGGLE_DRAWER(state) {
    state.drawerVisible = !state.drawerVisible
  },
  SET_DRAWER(state, visible) {
    state.drawerVisible = visible
  },
  SET_CONVERSATIONS(state, list) {
    state.conversations = list
  },
  SET_CURRENT_CONVERSATION(state, conversationId) {
    state.currentConversationId = conversationId
  },
  SET_MESSAGES(state, messages) {
    state.messages = messages
  },
  ADD_MESSAGE(state, message) {
    state.messages.push(message)
  },
  SET_LOADING(state, loading) {
    state.isLoading = loading
  },
  UPDATE_LAST_MESSAGE(state, content) {
    if (state.messages.length > 0) {
      const last = state.messages[state.messages.length - 1]
      if (last.role === 'assistant') {
        last.content = content
      }
    }
  }
}

const actions = {
  toggleDrawer({ commit }) {
    commit('TOGGLE_DRAWER')
  },

  newConversation({ commit }) {
    commit('SET_CURRENT_CONVERSATION', null)
    commit('SET_MESSAGES', [])
  },

  async sendChat({ commit, state }, { message, moduleContext }) {
    // 添加用户消息
    commit('ADD_MESSAGE', { role: 'user', content: message })
    commit('SET_LOADING', true)
    // 添加空的 AI 消息占位，后续流式填充
    commit('ADD_MESSAGE', { role: 'assistant', content: '' })

    try {
      const identity = localStorage.getItem('identity') || ''
      const response = await fetch('/openai-merch-api/ai/ChatStream', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'identity': identity
        },
        body: JSON.stringify({
          message: message,
          conversationId: state.currentConversationId || '',
          moduleContext: moduleContext || ''
        })
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`)
      }

      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''
      let accumulated = ''

      console.log('[SSE] Stream started')

      while (true) {
        const { done, value } = await reader.read()
        if (done) break

        const ts = new Date().toISOString().substr(11, 12)
        const chunk = decoder.decode(value, { stream: true })
        console.log(`[SSE] [${ts}] Raw chunk (${chunk.length} bytes):`, chunk.substring(0, 100))
        buffer += chunk
        const lines = buffer.split('\n')
        buffer = lines.pop() // 保留不完整行

        for (const line of lines) {
          if (!line.startsWith('data: ')) continue
          const dataStr = line.substring(6).trim()
          if (!dataStr) continue

          try {
            const data = JSON.parse(dataStr)
            console.log('[SSE] Parsed:', data)

            if (data.type === 'meta') {
              commit('SET_CURRENT_CONVERSATION', data.conversationId)
            } else if (data.type === 'chunk') {
              accumulated += data.content
              commit('UPDATE_LAST_MESSAGE', accumulated)
            } else if (data.type === 'done') {
              // 流式完成
            } else if (data.type === 'error') {
              commit('UPDATE_LAST_MESSAGE', data.message || '服务异常')
            }
          } catch (e) {
            // 跳过无法解析的行
          }
        }
      }

      console.log('[SSE] Stream ended')

      if (!accumulated) {
        commit('UPDATE_LAST_MESSAGE', '抱歉，未收到有效回复，请重试。')
      }
    } catch (error) {
      console.error('ChatStream error:', error)
      commit('UPDATE_LAST_MESSAGE', '抱歉，服务暂时不可用，请稍后重试。')
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async loadConversations({ commit }) {
    try {
      const res = await $command.execute({
        api: '/openai-merch-api/ai/GetConversationList',
        parameter: {}
      })
      commit('SET_CONVERSATIONS', res.data || [])
    } catch (error) {
      console.error('加载会话列表失败', error)
    }
  },

  async loadMessages({ commit }, conversationId) {
    if (!conversationId) return
    try {
      const res = await $command.execute({
        api: '/openai-merch-api/ai/GetConversationMessages',
        parameter: { conversationId }
      })
      commit('SET_MESSAGES', res.data || [])
      commit('SET_CURRENT_CONVERSATION', conversationId)
    } catch (error) {
      console.error('加载消息失败', error)
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
